export const ALERTS_DRAWER_OPEN_EVENT = 'contacttel:alerts-drawer-open' as const;
